module.exports = __webpack_public_path__ + "img/media-line-top.93adb36d.svg";